import { CLAIM_TYPE } from '@claim-os/shared';
import type { ClaimTableRow, EncounterResponse } from '@claim-os/shared';
import { caseDisplayNumber } from './caseDisplayNumber';
import { portalDisplayStatus } from './portalDisplayStatus';

/** The encounter's server rows, display-ready for a claims table. Status applies the portal
 *  edit-window rule here because the tables render what they are given; a claim only exists
 *  after its window has closed. */
export function toClaimTableRows(
  encounter: Pick<EncounterResponse, 'claimRows' | 'editableUntil'>,
): ClaimTableRow[] {
  return encounter.claimRows.map((row) => ({
    number: caseDisplayNumber(row.caseId),
    providerName: row.providerName ?? null,
    claimType: (CLAIM_TYPE as Record<string, string>)[row.billType] ?? row.billType,
    status: portalDisplayStatus(row.status, encounter.editableUntil, row.rowKind === 'CLAIM'),
    createdAt: row.createdAt,
  }));
}
